var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.error)?_c('hit_icon',{staticClass:"hit-text-danger",attrs:{"id":'remove'}}):_vm._e(),(!_vm.error)?_c('hit_icon',{staticClass:"hit-text-success",attrs:{"id":'ok'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }